export type ObbPassengerTypeCode = "PNOS" | "PCIL" | "PSOE" | "PINT";

export type ObbPassengerTypeOption = {
  code: ObbPassengerTypeCode;
  /** i18n key under transport.* */
  labelKey: string;
  /** Inclusive age range from product spec, for display */
  ageRange: string;
  isDefault?: boolean;
};

/**
 * Hardcoded ÖBB passenger types (frontend-only).
 * Source of truth: product table — Adult 15–64, Child 6–14, Senior 65–99, Infant 0–5.
 */
export const OBB_PASSENGER_TYPES: readonly ObbPassengerTypeOption[] = [
  {
    code: "PNOS",
    labelKey: "transport.obbPassengerTypeAdult",
    ageRange: "15–64",
    isDefault: true
  },
  {
    code: "PCIL",
    labelKey: "transport.obbPassengerTypeChild",
    ageRange: "6–14"
  },
  {
    code: "PSOE",
    labelKey: "transport.obbPassengerTypeSenior",
    ageRange: "65–99"
  },
  {
    code: "PINT",
    labelKey: "transport.obbPassengerTypeInfant",
    ageRange: "0–5"
  }
] as const;

export const DEFAULT_OBB_PASSENGER_TYPE_CODE: ObbPassengerTypeCode = "PNOS";

export function getDefaultObbPassengerType(): ObbPassengerTypeOption {
  const defaultType = OBB_PASSENGER_TYPES.find(type => type.isDefault);
  return defaultType ?? OBB_PASSENGER_TYPES[0];
}

export function getObbPassengerTypeByCode(code: string): ObbPassengerTypeOption | undefined {
  return OBB_PASSENGER_TYPES.find(type => type.code === code);
}

export function isObbPassengerTypeCode(code: string): code is ObbPassengerTypeCode {
  return OBB_PASSENGER_TYPES.some(type => type.code === code);
}
